module.exports = __webpack_public_path__ + "fonts/collegiatessinside-regular-webfont.eot";